import { useCallback, useState } from 'react';
import { API_URL } from '../../api';
import usePolling from '../../utils/usePolling';

const INTERVALL_MS = 5 * 60 * 1000;

/**
 * Systemhälsoindikatorn i sidhuvudet (bara systemadmin). Pollar
 * /system-health/quick var 5:e minut i synlig flik, pausar i dold flik.
 *
 * Utbruten ur Layout.js (A11 steg 1, 2026-10-07), usePolling i steg 2.
 *
 * @param {boolean} enabled Pollar bara när true (showSystemAdminNav)
 * @returns {'ok'|'warning'|'critical'|null}
 */
export default function useSystemHealthQuick(enabled) {
  const [sysHealthStatus, setSysHealthStatus] = useState(null);

  const poll = useCallback(async () => {
    try {
      const r = await fetch(`${API_URL}/system-health/quick`, { credentials: 'include' });
      if (!r.ok) return false;
      const d = await r.json();
      setSysHealthStatus(d.status || 'ok');
      return true;
    } catch {
      return false;
    }
  }, []);

  usePolling(poll, { intervalMs: INTERVALL_MS, enabled: Boolean(enabled) });

  return sysHealthStatus;
}
